import React from 'react';
import { observer } from 'mobx-react';
import { Item, Content, Info, Label, Editor } from '../Item';
import { SwitchCheckbox } from '../../../../components/SwitchCheckbox';
import styles from './Bool.m.sass';
var Bool = function Bool(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    readOnly = _ref.readOnly,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    checkout = _ref.checkout;
  var change = function change(newValue) {
    onChange(newValue);
    onUpdate();
  };
  return /*#__PURE__*/React.createElement(Item, {
    checkout: checkout,
    title: question.description
  }, /*#__PURE__*/React.createElement(Content, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Info, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Label, {
    checkout: checkout
  }, question.question)), /*#__PURE__*/React.createElement(Editor, {
    checkout: checkout
  }, readOnly ? /*#__PURE__*/React.createElement("div", {
    className: styles[answer ? 'true' : 'false']
  }, answer ? 'Yes' : 'No') : /*#__PURE__*/React.createElement(SwitchCheckbox, {
    trueLabel: "Yes",
    falseLabel: "No",
    value: answer,
    disabled: disabled,
    onChange: change
  }))));
};
export default observer(Bool);
//# sourceMappingURL=index.js.map
